import React from 'react';
import { hot, setConfig } from 'react-hot-loader';
import { Route, Switch, withRouter } from 'react-router-dom';
import { bool, object } from 'prop-types';
import { contains, map } from 'ramda';
import ROUTES, { allRoutes, defaultRoute, getPath } from '../../routes';
import AppBar from './components/AppBar/AppBar';
import CookieBanner from './components/CookieBanner/CookieBanner';
import SpinnerScreen from './components/SpinnerScreen/SpinnerScreen';
import ModalTimedout from './components/ModalTimedout/ModalTimedout';
import { useComponentDidMount, useConnect } from './hooks';
import ModalNpsConsent from './components/ModalNpsConsent/ModalNpsConsent';

setConfig({ logLevel: 'debug' });

const isLegislationRoute = contains(getPath(ROUTES.LEGISLATION));

const makeRoutes = () => (
  <Switch>
    {map(
      route => (
        <Route key={route.path} path={route.path} exact={route.exact} component={route.component} />
      ),
      allRoutes
    )}
    {defaultRoute && <Route component={defaultRoute.component} />}
  </Switch>
);

const App = ({ noContainer, location: { pathname } }) => {
  const {
    isFetching,
    isTimedout,
    settings,
    spinnerDeactivated,
    stepperMax,
    stepperValue,
    token,
    isEmbedded,
    isWorkflowBackButtonEnabled,
    isNpsEligibilityNeeded,
    isNpsEligibilityAvailable,
    back,
  } = useConnect();
  useComponentDidMount(settings);
  const isNpsConsent = isNpsEligibilityNeeded && !isNpsEligibilityAvailable;
  return (
    <div style={{ pointerEvents: isFetching ? 'none' : 'auto', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <AppBar
        stepperMax={stepperMax}
        stepperValue={stepperValue}
        settings={settings}
        isWorkflowBackButtonEnabled={isWorkflowBackButtonEnabled}
        back={back}
      />
      {!isLegislationRoute(pathname) && !noContainer && settings.COOKIE_WARNING && (
        <CookieBanner settings={settings} token={token} isEmbedded={isEmbedded} />
      )}

      {isFetching && !spinnerDeactivated && <SpinnerScreen />}
      {isTimedout && <ModalTimedout />}
      {isNpsConsent && <ModalNpsConsent />}
      {!noContainer && <div style={{ height: '100%' }}>{makeRoutes()}</div>}
    </div>
  );
};

App.propTypes = {
  noContainer: bool,
  location: object,
};

export default hot(module)(withRouter(App));
